"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");

var _infoHeader = require("./info-header.propTypes");

var _infoHeader2 = _interopRequireDefault(require("./info-header.css"));

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
    appendImageTransforms = dataUtils.appendImageTransforms;
var imageWidth = 1440;

var BackgroundImage = function BackgroundImage(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    src: appendImageTransforms(handleNestedProp(data, 'data.backgroundImage.image'), imageWidth),
    alt: handleNestedProp(data, 'data.backgroundImage.altText'),
    className: _infoHeader2["default"].backgroundImage,
    width: imageWidth
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _infoHeader2["default"].overlayGradient
  }));
};

var _default = BackgroundImage;
exports["default"] = _default;